import { createFileRoute, redirect } from '@tanstack/react-router';
import { JPMAM_ORDER_BASE_PATH } from '../../../../../../../../features/vendor/jpmam/order/jpmam-order-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/')({
  beforeLoad: () => {
    throw redirect({ to: JPMAM_ORDER_BASE_PATH });
  },
  preload: false,
});
